const merchandiseCredit = {
  merchandiseCredit: {
    noFile: 'Nie wybrano pliku',
    fileName: 'Nazwa pliku',
    software_service: 'Usługi dotyczące oprogramowania',
    hardware_product: 'Produkty sprzętowe',
    sampleFileNameUS: 'Środki na kupno towaru US',
    sampleFileNameAU: 'Środki na kupno towaru AU',
    sampleFileNameNL: 'Środki na kupno towaru NL',
    sampleFileNameBE: 'Środki na kupno towaru BE',
    sampleFileNameMX: 'Środki na kupno towaru MX',
    rowNumber: 'Numer wiersza',
    errorMessage: 'Wiadomość'
  }
};

export default merchandiseCredit;
